// extracted by mini-css-extract-plugin
export default {"centerImagesContainer":"CenterImages_centerImagesContainer__kteQ7","centerFruit":"CenterImages_centerFruit__930QP","centerVegetables":"CenterImages_centerVegetables__PZDt+"};